import { all } from 'redux-saga/effects';

import sso from './sso/sagas';

export default function* rootSaga(): Generator {
  return yield all([sso]);
}
